import main from './eye.svg';
import active from './eye-filled.svg';
import disabled from './eye-gestalt.svg';

export default { main, active, disabled };
